import React from "react";
import submit from "submit-form";

export const ReportsBackHandler = ({ title, locals, customBackUrl }) => {
  const handleBack = (e) => {
    if (locals?.query?.bodycomp) {
      e.preventDefault();
      history.back();
      //     submit("/actions/refresh", {
      //       method: "GET",
      //     });
    }
  };
  return (
    <a
      className="only-show-mobile"
      role="reports-back-handler"
      href={
        customBackUrl ||
        `/athlete-portal/metrics/reports-menu?athlete=${locals?.athlete?._id}`
      }
      onClick={handleBack}
    >
      <img src="/img/new-icons/arrow-left.svg" />
      <span>{title}</span>
    </a>
  );
};
